module.exports = __webpack_public_path__ + "img/ico_fxyj.6101f8e9.png";